/**
 * @generated SignedSource<<d55894d0b378cd91f56d4a4d9323f9c5>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type RedelegationRuleFragment$data = {
  readonly maxRedelegations: number;
  readonly " $fragmentType": "RedelegationRuleFragment";
};
export type RedelegationRuleFragment$key = {
  readonly " $data"?: RedelegationRuleFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"RedelegationRuleFragment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "RedelegationRuleFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "maxRedelegations",
      "storageKey": null
    }
  ],
  "type": "LiquidDelegationRules",
  "abstractKey": null
};

(node as any).hash = "9f302bae9d1ed3b3892503826a18ad75";

export default node;
